<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>
    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Mis Horarios</h1>
    </div>
  </div>

  <!-- Sections -->
  <div class="row-cols-12 m-2 mt-0">
    <div class="row p-3 mb-0 align-items-center">
      <div class="mb-3 mt-0 text-start">
        <form (ngSubmit)="saveHorarios()" [formGroup]="form">

          <!-- LUNES -->
          <div class="row mt-4 flex-nowrap">
            <div class="col d-flex align-items-center ps-0 pe-0 col-sm-4">
              <p class="form-label d-flex mb-0"><b>Lunes</b></p>
            </div>
            <div class="col col-sm-4 pe-2">
              <input type="time" class="form-control center-text pe-0 fsh" id="lunes_desde" formControlName="lunes_desde">
            </div>
            <div class="col col-sm-4">
              <input type="time" class="form-control center-text pe-0 fsh" id="lunes_hasta" formControlName="lunes_hasta">
            </div>
          </div>

          <!-- MARTES -->
          <div class="row mt-4 flex-nowrap">
            <div class="col d-flex align-items-center ps-0 pe-0 col-sm-4">
              <p class="form-label d-flex mb-0"><b>Martes</b></p>
            </div>
            <div class="col col-sm-4 pe-2">
              <input type="time" class="form-control center-text pe-0 fsh" id="martes_desde" formControlName="martes_desde">
            </div>
            <div class="col col-sm-4">
              <input type="time" class="form-control center-text pe-0 fsh" id="martes_hasta" formControlName="martes_hasta">
            </div>
          </div>

          <!-- MIERCOLES -->
          <div class="row mt-4 flex-nowrap">
            <div class="col d-flex align-items-center ps-0 pe-0 col-sm-4">
              <p class="form-label d-flex mb-0"><b>Miércoles</b></p>
            </div>
            <div class="col col-sm-4 pe-2">
              <input type="time" class="form-control center-text pe-0 fsh" id="miercoles_desde" formControlName="miercoles_desde">
            </div>
            <div class="col col-sm-4">
              <input type="time" class="form-control center-text pe-0 fsh" id="miercoles_hasta" formControlName="miercoles_hasta">
            </div>
          </div>

          <!-- JUEVES -->
          <div class="row mt-4 flex-nowrap">
            <div class="col d-flex align-items-center ps-0 pe-0 col-sm-4">
              <p class="form-label d-flex mb-0"><b>Jueves</b></p>
            </div>
            <div class="col col-sm-4 pe-2">
              <input type="time" class="form-control center-text pe-0 fsh" id="jueves_desde" formControlName="jueves_desde">
            </div>
            <div class="col col-sm-4">
              <input type="time" class="form-control center-text pe-0 fsh" id="jueves_hasta" formControlName="jueves_hasta">
            </div>
          </div>

          <!-- VIERNES -->
          <div class="row mt-4 flex-nowrap">
            <div class="col d-flex align-items-center ps-0 pe-0 col-sm-4">
              <p class="form-label d-flex mb-0"><b>Viernes</b></p>
            </div>
            <div class="col col-sm-4 pe-2">
              <input type="time" class="form-control center-text pe-0 fsh" id="viernes_desde" formControlName="viernes_desde">
            </div>
            <div class="col col-sm-4">
              <input type="time" class="form-control center-text pe-0 fsh" id="viernes_hasta" formControlName="viernes_hasta">
            </div>
          </div>

          <!-- SABADO -->
          <div class="row mt-4 flex-nowrap">
            <div class="col d-flex align-items-center ps-0 pe-0 col-sm-4">
              <p class="form-label d-flex mb-0"><b>Sábado</b></p>
            </div>
            <div class="col col-sm-4 pe-2">
              <input type="time" class="form-control center-text pe-0 fsh" id="sabado_desde" formControlName="sabado_desde">
            </div>
            <div class="col col-sm-4">
              <input type="time" class="form-control center-text pe-0 fsh" id="sabado_hasta" formControlName="sabado_hasta">
            </div>
          </div>

          <!-- DOMINGO -->
          <div class="row mt-4 flex-nowrap">
            <div class="col d-flex align-items-center ps-0 pe-0 col-sm-4">
              <p class="form-label d-flex mb-0"><b>Domingo</b></p>
            </div>
            <div class="col col-sm-4 pe-2">
              <input type="time" class="form-control center-text pe-0 fsh" id="domingo_desde" formControlName="domingo_desde">
            </div>
            <div class="col col-sm-4">
              <input type="time" class="form-control center-text pe-0 fsh" id="domingo_hasta" formControlName="domingo_hasta">
            </div>
          </div>

          <!-- FERIADOS -->
          <div class="row mt-4 flex-nowrap justify-content-between">
            <div class="col align-items-center form-switch ps-0 d-flex align-items-center justify-content-between">
              <label class="form-check-label" for="feriados_abierto"><b>Abierto los feriados</b></label>
              <input class="form-check-input ms-3" type="checkbox" id="feriados_abierto" formControlName="feriados_abierto">
            </div>
          </div>

          <!-- Error -->
          @if (error()) {
            <div class="alert alert-danger mt-2" role="alert">
              <small>{{ error() }}</small>
            </div>
          }

          <!-- Botón -->
          <div class="d-grid mt-5 mb-3 pb-3">
            <button
              type="submit"
              class="btn btn-primary btn-lg mt-0"
              [disabled]="loading() || form.disabled">
              {{ loading() ? 'Cargando...' : 'Guardar horarios' }}
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>